import React from 'react';

export default function NoActiveProject({ description }) {
    return (
        <div style={{ display: 'flex', flex: 1, height: '100%', width: '100%', justifyContent: 'center', alignItems: 'center', background: 'var(--bg-primary)', color: 'var(--text-secondary)', padding: '2rem' }}>
            <div style={{ maxWidth: '420px', textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '1.5rem', background: 'var(--bg-card)', padding: '2.5rem', borderRadius: 'var(--radius)', border: '1px solid var(--border)' }}>
                <i className="fa-solid fa-diagram-project" style={{ fontSize: '3rem', color: 'var(--accent)' }}></i>
                <div>
                    <h2 style={{ fontSize: '1.25rem', color: 'var(--text-primary)', marginBottom: '0.5rem' }}>No Active Project Selected</h2>
                    <p style={{ fontSize: '0.9rem', lineHeight: '1.5', margin: 0 }}>
                        {description || 'Select a project in the header, or create one from the project menu.'}
                    </p>
                </div>
            </div>
        </div>
    );
}
